import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Ranking from "@/pages/ranking/page";
import Topics from "@/pages/topics/page";
import Article from "@/pages/article/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "ranking",
        element: <Ranking />,
      },
      {
        path: "topics",
        element: <Topics />,
      },
      {
        path: "article/:id",
        element: <Article />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;